import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo/innovators-hub-no-background.png'


const _hoisted_1 = { id: "sticky-nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "header-nav-icon",
    src: _imports_0,
    style: {"width":"100px"},
    alt: "Innovators Hub logo"
  })
], -1)
const _hoisted_3 = {
  id: "mobile-overlay",
  class: "mobile-overlay"
}
const _hoisted_4 = { id: "mobile-overlay-link-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Offices", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "About us", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Partners", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Contact us", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { id: "nav-mobile-lang-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { id: "desktop-navbar" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<a class=\"nav-link action\" id=\"offices-nav\" href=\"/offices\"><span class=\"action\">Offices</span></a><a class=\"nav-link\" id=\"about-us-nav\" href=\"/#about-us\"><span>About us</span></a><a class=\"nav-link\" id=\"partners-nav\" href=\"/#partners\"><span>Partners</span></a><a class=\"nav-link\" id=\"contact-us-nav\" href=\"/#contact-us\"><span>Contact us</span></a>", 4)
const _hoisted_21 = { style: {"display":"inline-block"} }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "▿", -1)
const _hoisted_24 = { class: "language-dropdown-content" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["src", "alt"]

import {getCurrentInstance, ref} from "vue";
import FooterView from "@/components/FooterView.vue";
import Language from "@/types/enums/language";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const instance = getCurrentInstance();
const router = instance?.appContext.config.globalProperties.$routerUtils;
const translator = instance?.appContext.config.globalProperties.$translatorUtils;

const language = ref(localStorage.getItem("language") ?? "en");

function changeLanguage(language: string){
  translator.setLanguage(language);
  router.refreshCurrentPage();
}

translator.setLanguage(language.value);

const isLanguageDropdownVisible = ref(false);
const availableLanguages = Object.values(Language);

const toggleLanguageVisibility = () => {
  isLanguageDropdownVisible.value = !isLanguageDropdownVisible.value;
};
const isOverlayVisible = ref(false);

const toggleOverlay = () => {
  isOverlayVisible.value = !isOverlayVisible.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            id: "close-overlay-btn",
            onClick: toggleOverlay
          }, "X"),
          _createElementVNode("a", {
            class: "nav-link",
            href: "/offices",
            onClick: toggleOverlay
          }, _hoisted_6),
          _createElementVNode("a", {
            class: "nav-link",
            href: "/#about-us",
            onClick: toggleOverlay
          }, _hoisted_8),
          _createElementVNode("a", {
            class: "nav-link",
            href: "/#partners",
            onClick: toggleOverlay
          }, _hoisted_10),
          _createElementVNode("a", {
            class: "nav-link",
            href: "/#contact-us",
            onClick: toggleOverlay
          }, _hoisted_12),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableLanguages), (lang) => {
              return (_openBlock(), _createElementBlock("a", {
                key: lang,
                onClick: ($event: any) => (changeLanguage(lang)),
                class: "nav-mobile-lang-dropdown-item"
              }, [
                _createElementVNode("span", null, _toDisplayString(lang.toUpperCase()), 1),
                _createElementVNode("img", {
                  class: "nav-mobile-flag-icon",
                  src: require(`@/assets/images/language-flags/${lang}.svg`),
                  height: "12",
                  alt: language.value
                }, null, 8, _hoisted_15)
              ], 8, _hoisted_14))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, isOverlayVisible.value]
      ]),
      _createElementVNode("button", {
        class: "hamburger",
        id: "hamburger-btn",
        onClick: toggleOverlay
      }, "☰"),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            id: "nav-lang-btn",
            onClick: toggleLanguageVisibility
          }, [
            _createElementVNode("span", null, _toDisplayString(language.value.toUpperCase()), 1),
            _createElementVNode("img", {
              class: "nav-flag-icon",
              src: require(`@/assets/images/language-flags/${language.value}.svg`),
              height: "12",
              alt: language.value
            }, null, 8, _hoisted_22),
            _hoisted_23
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableLanguages), (lang) => {
              return (_openBlock(), _createElementBlock("a", {
                key: lang,
                onClick: ($event: any) => (changeLanguage(lang)),
                class: "nav-lang-dropdown-item"
              }, [
                _createElementVNode("span", null, _toDisplayString(lang.toUpperCase()), 1),
                _createElementVNode("img", {
                  class: "nav-flag-icon",
                  src: require(`@/assets/images/language-flags/${lang}.svg`),
                  height: "12",
                  alt: language.value
                }, null, 8, _hoisted_26)
              ], 8, _hoisted_25))
            }), 128))
          ])
        ], 512), [
          [_vShow, isLanguageDropdownVisible.value]
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _createVNode(FooterView)
  ], 64))
}
}

})